import React, {useEffect, useState} from "react";
import "../../sass/main.scss";
import CmnCard from "../CmnCard";

import caretLeftFill from "../../images/caret-left-fill.svg";
import caretRightFill from "../../images/caret-right-fill.svg";
import $ from "jquery";
import axios2 from "../../helpers/APIHelper";
import Paging from "../common/Paging";
import Fn from "../../libraries/Fn";
import JDatePicker from "../common/JDatePicker";
import {useHistory} from "react-router-dom";

const SecureExcelDownHistory = (props) => {
	
  window._load = (_page = 1) => {
    try {
      load(_page);
    } catch (e) {
    }
  }

  const [rets, setRets] = useState([]);
  const [pageInfo, setPageInfo] = useState({});
  const [currPage, setCurrPage] = useState(1);
  const [srchRenew, setSrchRenew] = useState(0);
  const history = useHistory();

  useEffect(() => {
    if (Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) < 9) {
      alert('메뉴 접근 권한이 없습니다.');
      history.goBack();
      return;
    }

    const today = Fn.getCurrentDate();
    const [year, month] = today.split("-");

    $('#s_date1').val(`${year}-${month}-01`);
    $('#s_date2').val(today);
  }, []);

  useEffect(() => {
    $('.fn_search_box').each(function () {
      $(this).find("input[type=text]").each(function () {
        $(this).onEnter(() => setSrchRenew(Fn.getRenewTime));
      });
    });
  }, []);

  useEffect(() => {
    if (!srchRenew) return;
    load(1);
  }, [srchRenew]);

  useEffect(() => {
    load();
  }, [currPage]);

  const load = (_page) => {
    axios2
      .post(`/secure/excel/down/history/ready?s_branch_code=${$('#s_branch_code option:selected').val() || ''}&s_date1=${$('#s_date1').val()}&s_date2=${$('#s_date2').val()}&s_down_page=${$('#s_down_page option:selected').val() || ''}&s_step_name=${$('#s_step_name').val()}&page=${_page || currPage}`)
      .then((response) => {
        const {code, message, result, pageInfo} = response?.data;
        if (code === 200) {
          if ($('#s_branch_code').html() === '') {
            let optionsHTML = '<option value="">::지점::</option>';
            result?.topList?.forEach((list_row) => {
              optionsHTML += `<option value="${list_row.branch_code}">${list_row.branch_name}</option>`;
            });
            $('#s_branch_code').html(optionsHTML);
          }

          setRets(result?.result1);
          setPageInfo(pageInfo);
        }
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      });
  }

  return (
    <CmnCard onLogout={props.onLogout}>
      <div className="d-flex m-3 fn_search_box" style={{maxWidth: "935px"}}>
        <div className="pr-1">
          <select className="form-select" id="s_branch_code">
          </select>
        </div>
        <div className="input-group pr-1" style={{width: "auto"}}>
          <JDatePicker className="form-control" aria-describedby="button-addon2" id="s_date1"/>
          <p className="mx-2">~</p>
          <JDatePicker className="form-control" aria-describedby="button-addon2" id="s_date2"/>
        </div>
        <div className="pr-1">
          <select className="form-select" id="s_down_page">
            <option value="">다운파일</option>
            <option value="엑셀저장(휴대폰)">엑셀저장(휴대폰)</option>
            <option value="엑셀저장(전체)">엑셀저장(전체)</option>
            <option value="엑셀저장(점장)">엑셀저장(점장)</option>
            <option value="엑셀저장(지부장)">엑셀저장(지부장)</option>
            <option value="라커목록">라커목록</option>
            <option value="비움라커목록">비움라커목록</option>
            <option value="PT진행내역">PT진행내역</option>
            <option value="앱웹결제내역">앱웹결제내역</option>
            <option value="쿠폰발급내역">쿠폰발급내역</option>
            <option value="SMS발송내역">SMS발송내역</option>
            <option value="스텝관리">스텝관리</option>
            <option value="만족도조사">만족도조사</option>
          </select>
        </div>
        <div className="pr-1">
          <input type="text" className="form-control" placeholder="스텝명 검색" id="s_step_name"/>
        </div>
        <div className="pr-1">
          <button type="button" className="btn btn-sm btn-point px-3" onClick={() => setSrchRenew(Fn.getRenewTime())}>검색</button>
        </div>
      </div>

      <div className="m-3 pb-2" style={{maxWidth: "935px"}}>
        <table className="view-rounded sub_table_border auto">
          <colgroup>
            <col width="65px"/>
            <col width="140px"/>
            <col width="170px"/>
            <col width="170px"/>
            <col width="70px"/>
            <col width="80px"/>
            <col width="*"/>
          </colgroup>

          <tr>
            <th>No</th>
            <th>지점명</th>
            <th>다운일시</th>
            <th>다운파일</th>
            <th>건수</th>
            <th>스텝명</th>
            <th>사유</th>
          </tr>
          {
            rets.map((row, i) => {
              const branch_name = row.branch_name;
              const down_date = row.down_date;
              const down_time = row.down_time;
              const down_page = row.down_page;
              const down_cnts = row.down_cnts;
              const step_name = row.step_name;
              const down_qry = row.down_qry.replace(/'/g, "\\'");
              const down_reason = row.down_reason;

              return (
                <tr key={i}>
                  <td>{pageInfo.totalArticles - pageInfo.articlesPerPage * (pageInfo.currentPage - 1) - i}</td>
                  <td>
                    <div align="left" style={{paddingLeft: '10px'}}>{branch_name}</div>
                  </td>
                  <td>{down_date} {down_time}</td>
                  <td>{down_page}</td>
                  <td>{down_cnts}</td>
                  <td>{step_name}</td>
                  <td>
                    <div align="left" style={{paddingLeft: '10px'}}>{down_reason}</div>
                  </td>
                </tr>
              );
            })
          }
          {(!rets || rets?.length === 0) &&
            <tr>
              <td colSpan={7}>※ 등록된 data가 없습니다.</td>
            </tr>
          }
        </table>
      </div>

      <nav className="m-3 p-3 mb-4 d-flex justify-content-center border-top" style={{maxWidth: "935px"}}>
        <Paging pageInfo={pageInfo} setCurrPage={page => setCurrPage(page)}/>
      </nav>

    </CmnCard>
  );
};

export default SecureExcelDownHistory;
